import { mix, passthruLayout } from "@chorda/core";
export var Color;
(function (Color) {
    Color["Success"] = "is-success";
    Color["Danger"] = "is-danger";
})(Color || (Color = {}));
export const Field = (props) => {
    const isLabel = props.label != null;
    const isHelp = !!props.help;
    const isContent = !!props.control;
    const isAddons = !!props.addons;
    const isColor = !!props.color;
    const isHorizontal = !!props.horizontal;
    return mix({
        css: 'field',
        templates: {
            label: {
                css: 'label'
            },
            control: {
                css: 'control'
            },
            addons: {
                layout: passthruLayout
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        classes: {
            'has-addons': isAddons,
            'horizontal': isHorizontal,
        },
        components: {
            label: isLabel,
            control: isContent,
            addons: {
                templates: props.addons,
                defaultComponent: props.addonAs,
            }
        },
        templates: {
            label: {
                text: props.label
            },
            control: {
                classes: {
                    'is-expanded': props.expanded
                },
                templates: {
                    content: {
                        classes: {
                            [props.color]: isColor
                        }
                    },
                    help: {
                        css: 'help',
                        text: props.help,
                        classes: {
                            [props.color]: isColor
                        }
                    }
                },
                components: {
                    content: props.control,
                    help: isHelp
                }
            }
        }
    });
};
